var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.28613 6.42857L5.41477 16.5863C5.49516 17.3098 6.10668 17.8571 6.83461 17.8571H13.1662C13.8942 17.8571 14.5057 17.3098 14.5861 16.5863L15.7147 6.42857",
    stroke: "black",
    strokeWidth: 1.42857,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.57129 4.28571H16.4284",
    stroke: "black",
    strokeWidth: 1.42857,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.85742 4.28571V3.57143C7.85742 2.78245 8.49702 2.14286 9.28599 2.14286H10.7146C11.5035 2.14286 12.1431 2.78245 12.1431 3.57143V4.28571",
    stroke: "black",
    strokeWidth: 1.42857,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.85742 8.57143L8.57171 12.8571",
    stroke: "black",
    strokeWidth: 1.42857,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1426 8.57143L11.4283 12.8571",
    stroke: "black",
    strokeWidth: 1.42857,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcTrash);
export default __webpack_public_path__ + "static/media/ic_trash.af7caed1eb80778e220488f82d680571.svg";
export { ForwardRef as ReactComponent };